import axios from "axios";
import * as d3 from "d3";
import Plotly from "plotly.js-dist-min"

export default function (chart, divId, vizName, filterParam) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar
    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    axios.post(url, filterParam).then(res => {

        let result = res.data;


        var dobj = {}, z = [], x = [], y = [], data = [];

        result.forEach(function (d) {
            d.metric1 = +d.metric1;
            d.metric2 = +d.metric2;
            d.metric3 = +d.metric3
        });

        for (var i = 0; i < result.length; i++) {
            z.push(result[i].metric3);
            x.push(result[i].metric1);
            y.push(result[i].metric2);
        }
        dobj['z'] = z;
        dobj['x'] = x;
        dobj['y'] = y;
        dobj['type'] = 'contour';
        dobj['xaxis'] = 'metric1';
        dobj['yaxis'] = 'metric2';
        dobj['colorscale'] = 'Jet';
        dobj['contours'] = {
            'showlabels': true,
            'labelfont': {'family': 'sans-serif', 'size': axisLabelFontSize, 'color': 'black'},
            'start': Math.round(d3.min(result, (d) => {
                return d.metric3
            })),
            'end': Math.round(d3.max(result, (d) => {
                return d.metric3
            })),
            'size': chart.vizSpecific1
        }

        data.push(dobj)

        //console.log(pdata)
        var layout = {
            title: 'contour',
            xaxis: {
                title: {
                    text: chart.x1AxisDisplayName,
                    font: {
                        family: 'sans-serif',
                        size: fontSize,
                        color: fontColor
                    }
                }
            },
            yaxis: {
                title: {
                    text: chart.y1AxisDisplayName,
                    font: {
                        family: 'sans-serif',
                        size: fontSize,
                        color: fontColor
                    }
                }
            },
        };

        Plotly.newPlot(divId, data, layout, {displaylogo: false, editable: false});
    });
}
